<template>
    <div class="front">
        <section id="intro">
            <div class="intro-container">
                <div id="introCarousel" class="carousel  slide carousel-fade" data-ride="carousel">

                    <ol class="carousel-indicators"></ol>

                    <div class="carousel-inner" role="listbox">
                        <template v-for="(item,index) in acceuils">
                            <transition name="fade">
                                <carousel-item
                                        :item="item"
                                        :index="index"
                                        :slide-active="slideActive"/>
                            </transition>
                        </template>
                    </div>

                    <a class="carousel-control-prev"
                       href="javascript:void(0)"
                       @click="prev"
                       role="button"
                       data-slide="prev">
                        <span class="carousel-control-prev-icon ion-chevron-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>

                    <a class="carousel-control-next"
                       href="javascript:void(0)"
                       @click="next"
                       role="button"
                       data-slide="next">
                        <span class="carousel-control-next-icon ion-chevron-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>

                </div>
                <!-- Floating CTA for public versions -->
                <!-- <a class="floating-versions-cta" href="https://newness.ovh/multitrade" target="_blank" rel="noopener" aria-label="Voir les versions publiques de MultiTRADE">
                    <span class="pulse"></span>
                    <i class="ion-ios-cloud-download"></i>
                    <span class="label">Versions</span>
                </a> -->
            </div>
        </section>
    </div>
</template>

<script>
    import {mapActions,mapState} from 'vuex'

    import CarouselItem from "../../layout/component/CarouselItem";
    export default {
        name: "index",
        components: {CarouselItem},
        data(){
            return {
                slideActive: 0
            }
        },
        computed:{
          ...mapState({
              acceuils: (state) => state.acceuil.acceuils
          })
        },
        mounted() {
           setInterval(this.next, 12000);
            this.acceuilAllAction()
        },
        methods:{
            ...mapActions('acceuil',['acceuilAllAction']),
            next(){
                if(this.slideActive >= this.acceuils.length - 1){
                    this.slideActive = 0
                }else {
                    this.slideActive++
                }
            },
            prev(){
                if(this.slideActive <= 0){
                    this.slideActive = this.acceuils.length - 1
                }else {
                    this.slideActive--
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    /* Floating Versions CTA */
    .floating-versions-cta {
        position: absolute;
        right: 24px;
        bottom: 24px;
        z-index: 12;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        border-radius: 12px;
        background: rgba(22, 160, 133, 0.92);
        color: #fff;
        box-shadow: 0 8px 28px rgba(0,0,0,0.25);
        backdrop-filter: saturate(1.2) blur(2px);
        text-decoration: none;
        transform: translateY(0);
        transition: transform .18s ease, box-shadow .2s ease, background .2s ease;
    }
    .floating-versions-cta:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 34px rgba(0,0,0,0.30);
        background: rgba(26, 188, 156, 0.96);
    }
    .floating-versions-cta .label { font-weight: 600; letter-spacing: .2px; }
    .floating-versions-cta .pulse {
        position: absolute;
        inset: 0;
        border-radius: 12px;
        box-shadow: 0 0 0 0 rgba(26, 188, 156, .6);
        animation: pulse 2.4s infinite;
        pointer-events: none;
    }
    @keyframes pulse {
        0% { box-shadow: 0 0 0 0 rgba(26, 188, 156, .55); }
        70% { box-shadow: 0 0 0 14px rgba(26, 188, 156, 0); }
        100% { box-shadow: 0 0 0 0 rgba(26, 188, 156, 0); }
    }

    /* Responsive: hide label on very small screens */
    @media (max-width: 576px) {
        .floating-versions-cta { padding: 10px; gap: 8px; }
        .floating-versions-cta .label { display: none; }
    }
</style>